import * as React from 'react';
import { LANGUAGE_LABELS } from '../Language/en';

export interface IndPrefLangRendererProps {
  value: string;
}

export const IndPrefLangRenderer = (props: IndPrefLangRendererProps): string => {
  const [renderedValue, setRenderedValue] = React.useState<string>(null);
  const [value, setValue] = React.useState<string>(props.value);

  React.useEffect(() => {
    const findLanguage = LANGUAGE_LABELS.find((languageSingle) => languageSingle.value === value);

    if (findLanguage) {
      setRenderedValue(findLanguage.label);
    }
  }, []);

  return renderedValue || value;
};
